import { render, staticRenderFns } from "./PI.vue?vue&type=template&id=9a6889de&scoped=true&"
import script from "./PI.vue?vue&type=script&lang=js&"
export * from "./PI.vue?vue&type=script&lang=js&"
import style0 from "./PI.vue?vue&type=style&index=0&id=9a6889de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a6889de",
  null
  
)

export default component.exports